var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "report-ticket" } }, [
    _c("div", { staticClass: "overall-content" }, [
      _c("div", { staticClass: "chart-container" }, [
        _c("div", { staticClass: "report-card" }, [
          _c("div", { staticClass: "report-card-header" }, [
            _c(
              "div",
              { staticClass: "report-card-icon users-icon" },
              [_c("md-icon", [_vm._v("people")])],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "report-card-title" }, [
              _c("h2", [_vm._v(_vm._s(_vm.$t("report.ticketCountByUser")))]),
              _vm._v(" "),
              _c("p", { staticClass: "report-card-subtitle" }, [
                _vm._v(_vm._s(_vm.$t("report.ticketCountByUserDesc"))),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "report-card-body" },
            [
              _c("TicketDistributionsByUser", {
                attrs: {
                  filters: _vm.filters,
                  loading: _vm.loading,
                  data: _vm.data.byUser,
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "report-card" }, [
          _c("div", { staticClass: "report-card-header" }, [
            _c(
              "div",
              { staticClass: "report-card-icon status-icon" },
              [_c("md-icon", [_vm._v("donut_large")])],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "report-card-title" }, [
              _c("h2", [_vm._v(_vm._s(_vm.$t("report.ticketCountByStatus")))]),
              _vm._v(" "),
              _c("p", { staticClass: "report-card-subtitle" }, [
                _vm._v(_vm._s(_vm.$t("report.ticketCountByStatusDesc"))),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "report-card-body" },
            [
              _c("TicketDistributionsByStatus", {
                attrs: {
                  filters: _vm.filters,
                  loading: _vm.loading,
                  data: _vm.data.byStatus,
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "report-card" }, [
          _c("div", { staticClass: "report-card-header" }, [
            _c(
              "div",
              { staticClass: "report-card-icon timeseries-icon" },
              [_c("md-icon", [_vm._v("timeline")])],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "report-card-title" }, [
              _c("h2", [_vm._v(_vm._s(_vm.$t("report.ticketCountByStatus")))]),
              _vm._v(" "),
              _c("p", { staticClass: "report-card-subtitle" }, [
                _vm._v(_vm._s(_vm.$t("report.ticketCountTimeseriesDesc"))),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "report-card-body" },
            [
              _c("TicketCountTimeSeriesChart", {
                attrs: {
                  filters: _vm.filters,
                  loading: _vm.loading,
                  data: _vm.data.timeSeries,
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }